import { Text, TextProps } from "@chakra-ui/react";

export const Subject = ({ children, sx }: { children: React.ReactNode; sx?: TextProps }) => {
  return (
    <Text
      sx={{
        maxW: '200px',
        fontSize: 'sm',
        fontWeight: 'semibold',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {children}
    </Text>
  )
}
